import React from 'react';

const BulkCompletedModel = ({ isOpen, onClose , data,handleBack}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white  w-[575px] h-[441px] p-[44px] flex flex-col justify-between rounded-2xl shadow-xl">
        <div className='flex justify-between w-full items-center mb-8'>
          <div className="text-2xl font-bold">Bulk Operation Completed</div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
          >
            ×
          </button>
        </div>

        <div className='flex flex-col gap-6 mb-8'>
          <div className="text-lg grid grid-cols-[auto,30px,60px] items-center gap-4">
            <span className="font-bold">Successfully uploaded leads</span>
            <span className="text-center">:</span>
            <span className="text-xl font-semibold ">{data?.uploadedCount}</span>
          </div>
          <div className="text-lg grid grid-cols-[auto,30px,60px] items-center gap-4">
            <span className="font-bold">No of Invalid leads</span>
            <span className="text-center">:</span>
            <span className="text-xl font-semibold text-red-500 ">{data?.invalidCount}</span>
          </div>
          <div className="text-lg grid grid-cols-[auto,30px,60px] items-center gap-4">
            <span className="font-bold">No of Duplicate leads</span>
            <span className="text-center">:</span>
            <span className="text-xl font-semibold text-red-500 ">{data?.duplicateCount}</span>
          </div>
        </div>
        <div className='text- flex flex-col gap-1'>
            <div className='font-semibold text-red-600'>NOTE :</div>
            <p>
            The detailed report containing Invalid Leads and Duplicate Leads has been sent to the registered admin email. Please check your inbox for more details
            </p>
        </div>

        <div className='flex justify-center mt-2 '>
          <button onClick={handleBack} className="w-32 text-white bg-customGreen py-3 rounded-md font-bold text-lg">
            Okay
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkCompletedModel;